/**
 * Emit hosts for the `note` analytics group — 3 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { SegmentActionName, SegmentObjectName } from '@/models/analytics/segment-names';

/** Count AskAI completions only. Never reintroduce clinician command text into telemetry. */
export function noteGeneratedByAskAI(): void {
  trackLegacyEvent({
    name: SegmentObjectName.Note,
    props: {
      action: SegmentActionName.NoteGeneratedByAskAI,
    },
  });
}

export function noteGeneratedByPressAICommand(aiCommandId: string) {
  trackLegacyEvent({
    name: SegmentObjectName.Note,
    props: {
      action: SegmentActionName.NoteGeneratedByPressAICommand,
      aiCommandId,
    },
  });
}

export function noteGeneratedByTemplate(templateId: string) {
  trackLegacyEvent({
    name: SegmentObjectName.Note,
    props: {
      action: SegmentActionName.NoteGeneratedByTemplate,
      templateId,
    },
  });
}
